import { breakpoints } from '../helpers/variables';

class SearchGen {
 breakpoint = window.matchMedia(
    `(max-width: ${breakpoints.tabletLandscape - 1}px)`
  );

  constructor() {
   this.init();
  }

   getLanguageCodeFromUrl() {
    const url = window.location.href;
    console.log('URLMard', url );
    const path = window.location.pathname;
    //console.log('Pathname', path );
    const pathSegments = path.split('/');
    //console.log('Segments', pathSegments );
    if (pathSegments.length > 1) {
      return pathSegments[1];
    }
    return null;
  }


  init() {
    const languageCode = this.getLanguageCodeFromUrl();

    if (languageCode === '/') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=en_US';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "acbc36d6-5b83-4156-b4c9-ddcff7396ec2");    
      }
    } else if (languageCode === 'fr-fr') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=fr_FR';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "50174bd4-263b-4885-9beb-335f1e2fa6aa");    
      }
    } else if (languageCode === 'de-de') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=de_DE';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "1723bd6c-79c1-436d-8c23-025b3d453641");    
      }
    } else if (languageCode === 'en-au') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=en_AU';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "9fa83a97-7f05-422b-8a81-f1d5b4aea36c");    
      }
    } else if (languageCode === 'en-gb') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=en_UK';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "b704d912-07cc-4163-bd69-861cf2fdff65");    
      }
    } else if (languageCode === 'en-in') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=en_IN';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "31291c86-64d0-47b9-8e65-d963decac6f0");    
      }
    } else if (languageCode === 'en-sg') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=en_SG';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "60bcb72f-63e3-48de-b458-655e3493b1ae");    
      }
    } else if (languageCode === 'es-xl') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=es_XL';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "59317bb1-0f85-4501-b3c8-a1633bd9c2c5");    
      }
    } else if (languageCode === 'it-it') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=it_IT';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "5d71e73e-93bd-4e87-86dc-1ff32e540843");    
      }
    } else if (languageCode === 'ja-jp') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=ja_JP';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "4daf820f-6f2c-4dc3-abd7-022e3f151050");    
      }
    } else if (languageCode === 'pt-br') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=pt_BR';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "08416265-19f8-4b78-b577-205786f6ab9e");    
      }
    } else if (languageCode === 'nl-nl') {
      // Set script in head
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=nl_NL';
      script.type = 'text/javascript';
      document.head.appendChild(script);
      // Set config attribute
      const searchGenDiv: HTMLElement | null = document.getElementById('searchWidg');
      if (searchGenDiv) {      
        searchGenDiv.setAttribute("configid", "08416265-19f8-4b78-b577-205786f6ab9e");    
      }
    } 
  }

}

export default SearchGen;